import ApiClient from "../api/ApiClient";
import RecordsWithParams from "../../model/RecordsWithParams";
import { NumberishId } from "../../model/type";
import { OfferMedium } from "../../model/OfferMedium";
import { DataQueryParamsInterface } from "../../model/DataQueryParams";
import { OfferCreatorFilterParams } from "../../model/filter-params/OfferCreatorFilterParams";

export default class OfferMediumsDao {
    private apiClient: ApiClient;

    constructor(apiClient: ApiClient) {
        this.apiClient = apiClient;
    }

    public findAll(offerId: NumberishId, dataQueryParams: DataQueryParamsInterface<OfferCreatorFilterParams>): Promise<RecordsWithParams<OfferMedium>> {
        return this.apiClient.offers_Id_Mediums.get(offerId, dataQueryParams)
            .then(response => response.data)
    }

    public findAllMediumIds(offerId: NumberishId): Promise<NumberishId[]> {
        return this.apiClient.offers_Id_Mediums.get(
            offerId,
            {
                pagination: {
                    page: 1,
                    size: 100000,
                    sort: [],
                }
            },
            false
        ).then(response => response.data.records.map(record => record.mediumId));
    }
}

